export default "__VITE_ASSET__BLP$XERj__"